import { render, staticRenderFns } from "./NativeNotificationPrompt.vue?vue&type=template&id=9fb1edfa&scoped=true"
import script from "./NativeNotificationPrompt.vue?vue&type=script&lang=js"
export * from "./NativeNotificationPrompt.vue?vue&type=script&lang=js"
import style0 from "./NativeNotificationPrompt.vue?vue&type=style&index=0&id=9fb1edfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb1edfa",
  null
  
)

export default component.exports